import jq from 'jquery';
import { setCookie, getCookie } from '@shared/cookie';
import { cookieBase } from 'server-data/flconfigs';

let fields = [];
let storage;
let name;

const CookieStorage = function () {
  this.setItem = (name, dataStr) => {
    setCookie(cookieBase + name, dataStr, 30);
  };

  this.getItem = name => getCookie(cookieBase + name);
};

const LocalStorage = function () {
  this.setItem = (name, dataStr) => {
    window.localStorage.setItem(name, dataStr);
  };

  this.getItem = name => window.localStorage.getItem(name);
};

function init(autoFillName, inputFields) {
  name = autoFillName;
  fields = inputFields;
  storage = getStorage();
}

function hasLocalStorage() {
  if (typeof localStorage !== 'undefined') {
    const test = 'localStorage';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
}

function getStorage() {
  const isLocalStorageAvailable = hasLocalStorage();
  if (isLocalStorageAvailable) {
    return new LocalStorage();
  }

  return new CookieStorage();
}

function storeFormData() {
  const data = {};
  jq.each(fields, (key, value) => {
    if (jq(`[name=${value} ]`).is(':radio')) {
      data[value] = jq(`[name=${value} ]:checked`).val();
    } else {
      data[value] = jq(`[name=${value} ]`).val();
    }
  });
  storage.setItem(name, JSON.stringify(data));
}

function loadFormData() {
  return JSON.parse(storage.getItem(name)) || {};
}

function fillFormData() {
  const obj = loadFormData();
  jq.each(obj, fillData);
}

function fillData(key, value) {
  if (typeof value !== 'undefined') {
    if (jq(`[name=${key}]`).size() > 1) {
      jq(
        `[name=${key}][id !=fb_looking_for_work][id !=fb_looking_to_hire]`,
      ).val(function () {
        return jq(this).is(':radio') ? [value] : value;
      });
    } else {
      jq(`[name=${key} ]`).val(function () {
        return jq(this).is(':radio') ? [value] : value;
      });
    }
  }
}

function fillFormFromURL() {
  const data = {};
  const sURLVariables = window.location.search.substring(1).split('&');
  for (let i = 0; i < sURLVariables.length; i++) {
    const sParameterName = sURLVariables[i].split('=');
    data[sParameterName[0]] = sParameterName[1];
  }

  jq.each(data, fillData);
}

export default {
  init,
  storeFormData,
  fillFormData,
  fillFormFromURL,
};
